<template>
    <span>
        <transition
            name="fade"
            mode="out-in"
        >
            <p
                v-show="editingCard"
                class="update-card-title"
            >
                Enter new credit card info
            </p>
        </transition>
        <update-card
            title="Use the existing credit card"
            :without-subscription="withoutSubscription"
            @stripe-success="$emit('stripe-success')"
            @card-form-switch="$emit('change', ! editingCard)"
            @update-finished="$emit('update-finished')"
        />
    </span>
</template>

<script>
import UpdateCard from '@/components/Billing/UpdateCard';

export default {
    components: {
        UpdateCard,
    },

    props: {
        editingCard: {
            type: Boolean,
            required: true,
        },
        withoutSubscription: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
